module.exports = __webpack_public_path__ + "1e54f76ee4dbbfe3e1bf37ae7c2927f3.png";